import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { toast } from 'react-toastify';
import AddStaffModal from './AddStaff';
import Swal from 'sweetalert2';

const AllStaff = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);
    const url = process.env.REACT_APP_LINK;
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        email: "",
        password: "",
        full_name: "",
        mobile: ""
    })


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/staff/admin1997`);
            const data = await response.json();
            setEmployees(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    // Fetch users from backend
    useEffect(() => {


        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const isEdit = data.id !== undefined;
        const urlmain = isEdit
            ? `${url}/api/staff/change/${data.id}`
            : `${url}/api/staff/signup`;
        const method = isEdit ? 'PUT' : 'POST';

        const payload = {
            email: data.email,
            password: data.password || null,
            full_name: data.full_name || null,
            mobile: data.mobile,
        };

        try {
            const res = await fetch(urlmain, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    email: result.email,
                    password: result.password,
                    full_name: result.full_name,
                    mobile: result.mobile,

                };


                toast.success(isEdit ? 'Staff updated' : 'Staff added');
                //    fetchCoupon();
                // setCoupons(prev => isEdit
                //     ? prev.map(c => c.id === result.id ? mappedResult : c)
                //     : [...prev, mappedResult]
                // );

                fetchUsers();
                setIsModalOpen(false);
                setData({
                    email: "",
                    password: "",
                    full_name: "",
                    mobile: "",

                });
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        } finally {
            setLoading(false)
        }
    };


    const handleDelete = async (id) => {
        // Step 1: Show confirmation
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                // Step 2: Delete API call
                const response = await fetch(`${url}/api/staff/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    // Step 3: Update local state
                    const updatedEmployees = employees.filter(employee => employee.id !== id);
                    setEmployees(updatedEmployees);

                    // Step 4: Show success alert
                    Swal.fire("Deleted!", res.message || "Staff has been deleted.", "success");
                } else {
                    // Step 5: Show error alert
                    Swal.fire("Error!", res.error || "Something went wrong.", "error");
                }
            } catch (error) {
                console.log(error);
                Swal.fire("Error!", "Something went wrong.", "error");
            }
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">All Staff</h1>
                    <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            email: "",
                            password: "",
                            full_name: "",
                            mobile: "",

                        });
                    }}>
                        Add Staff
                    </button>
                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Email ID</th>
                                <th style={{ minWidth: "100px" }}>Name</th>
                                <th>Number</th>

                                <th>User Id</th>
                                <th>Last Login</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                        <td>{employee.email}</td>

                                        <td>{employee.full_name}</td>
                                        <td>{employee.mobile}</td>

                                        <td>{employee.user_id}</td>
                                        <td>{new Date(employee.last_login).toLocaleString()}</td>
                                        <td>{new Date(employee.createdAt).toLocaleString()}</td>
                                        <td>
                                            <button className="edit-button"
                                                onClick={() => {
                                                    setData({
                                                        id: employee.id, // include ID for PUT request
                                                        email: employee.email,
                                                        password: employee.password || "",
                                                        mobile: employee.mobile || "",
                                                        full_name: employee.full_name,
                                                        // end: employee.end_date,
                                                        // used_by: employee.used_by,
                                                    });
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button className="delete-button" onClick={() => handleDelete(employee.id)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                        {/* <td>
                                            <button onClick={() => handleDelete(employee.email)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No staff found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">{currentPage}</button>

                    {currentPage + 1 < totalPages && (
                        <>
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                            {currentPage + 2 < totalPages && <span className="dots">...</span>}
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    {currentPage === totalPages - 1 && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>
            <AddStaffModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
                loading={loading}
            />
        </>
    );
};

export default AllStaff;
